import { createSlotRecipe } from './runtime.js';

const ratingGroupConfig = {"name":"ratingGroup","slots":["root","label","control","item","icon","halfFill","hiddenInput"],"defaultVariants":{"color":"warning","size":"md"},"variantMap":{"color":["brand","error","info","primary","success","warning"],"size":["lg","md","sm","xs"]}}

export const ratingGroup = /* @__PURE__ */ createSlotRecipe(ratingGroupConfig)